import {adicRestApi, adicRestApiJobUrl} from '../index';

export const getJobMainList = async (jobUrl) => {
  const url = adicRestApiJobUrl
    .segment("/global/list")
    .query(jobUrl)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getJobEmployeeList = async (pageNumber, pageSize) => {
  const url = adicRestApiJobUrl
    .segment("/employee/list")
    .query(pageNumber, pageSize)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getJobList = async (searchQuery = {}) => {
  const {category, pageNumber, pageSize} = searchQuery;
  const url = adicRestApiJobUrl
    .segment("/:category/list")
    .param({ category })
    .query({pageNumber, pageSize})
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getJobDetail = async (category, ukey) => {
  const url = adicRestApiJobUrl
    .segment("/:category/info")
    .param({ category })
    .query({ukey})
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};
